import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import StatusCapsual from '../../components/DataTable/StatusCapsule';
import DateBox from '../../components/General/DateBox';
import ExamDetails from './SuperAdmin/ExamDetails';
import ExamCounter from './SuperAdmin/ExamCounter';
import AttendanceProgress from './SuperAdmin/AttendanceProgress';
import ReportingProgress from './SuperAdmin/ReportingProgress';
import RRBContacts from './SuperAdmin/RRBContacts';
import RRBExamSchedule from './SuperAdmin/RRBExamSchedule';
import { FormFieldSelect } from '../../components/Form/FormField';
import { get, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getAll } from '../../api/MinistryExams';
import * as RrbApi from '../../api/RrbAPI';
import {
  getDashboardDetails,
  getDashboardDetailsById,
  getDashboardDetailsByMinistryId,
} from '../../api/DashboardAPI';
import moment from 'moment';
import NoDataFound from '../../components/General/NoDataFound';
import useIsMobile from '../../hooks/useIsMobile';
import Loader from '../../components/Loader';
import IncidentAnalytics from './SuperAdmin/IncidentAnalytics';
import AadharCandidates from './SuperAdmin/AadharCandidates';

const SuperAdminDashboard = ({
  data = {},
  setDashboard,
  setParentLoading,
  parentLoading,
}) => {
  const isMobile = useIsMobile();
  const [exams, setExams] = useState([]);
  const [examDays, setExamDays] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const defaultFilterValue = {
    exam: '',
  };
  const {
    control,
    formState: { errors: dashboardFilterError },
    watch,
    setValue,
    getValues,
  } = useForm({
    mode: 'onChange',
    defaultValues: defaultFilterValue,
  });
  const [filter, setFilter] = useState({
    _page: 1,
    _limit: 1000,
    q: '',
    _sort: '',
    _order: 'desc',
    // status:"1"
  });
  // Function to get the exam days with the maximum number of days
  const [rrbs, setRrbs] = useState([]);
  const getExamDaysWithMaxDays = (data) => {
    let maxDaysExam = null;
    let maxDaysCount = 0;

    if (data) {
      data.Exams.forEach((exam) => {
        const examDaysCount = exam.examDays.length;

        if (examDaysCount > maxDaysCount) {
          maxDaysCount = examDaysCount;
          maxDaysExam = exam;
        }
      });
      if (maxDaysExam && maxDaysExam.examDays) {
        // Sort examDays by date in ascending order
        maxDaysExam.examDays.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );
      }

      return maxDaysExam ? maxDaysExam?.examDays : [];
    }
  };
  const fetchAllMinistryExams = async () => {
    let exams = await getAll(filter);

    // const today = new Date();
    // const todayStart = new Date(today.setHours(0, 0, 0, 0)); // Start of today

    // exams.data.records = exams.data.records.filter(
    //   (record) => new Date(record.shift_1_start_time) < todayStart
    // );

    setExams(exams.data.records);
  };
  useEffect(() => {
    fetchAllMinistryExams();
    localStorage.removeItem('selectedExam');
    localStorage.removeItem('selectedExamDay');
  }, []);
  const fetchDashboardData = useCallback(
    async (ministry_id, examDayId = null, incident_rrb) => {
      setParentLoading(true);
      try {
        if (ministry_id) {
          const res = await getDashboardDetailsByMinistryId(
            ministry_id,
            examDayId,
            null,
            incident_rrb
          );
          setDashboard(res.data);
        }
      } catch (error) {
        console.log('🚀 ~ fetchDashboardData ~ error:', error);
      } finally {
        setParentLoading(false);
      }
    },
    []
  );
  const selectedExam = watch('exam');
  const selectedExamDay = watch('examDay');

  useEffect(() => {
    setValue('examDay', []);
    if (selectedExam) {
      const examDays = getExamDaysWithMaxDays(
        exams.find((exam) => exam.id === selectedExam.value)
      );
      setExamDays(examDays);
      fetchDashboardData(selectedExam.value);
      localStorage.setItem('selectedExam', JSON.stringify(selectedExam));
    }
  }, [selectedExam]);
  useEffect(() => {
    if (selectedExamDay) {
      setValue('rrb', null);
      fetchDashboardData(selectedExam.value, selectedExamDay.value);

      localStorage.setItem('selectedExamDay', JSON.stringify(selectedExamDay));
    }
  }, [selectedExamDay]);

  useEffect(() => {
    if (!selectedExam.value) {
      const ministry_exam_id = data?.onGoingExamsStats?.exam?.ministry_exam_id;
      const exam = data?.onGoingExamsStats?.exam?.exam_name;
      if (ministry_exam_id && exam) {
        setValue('exam', {
          label: exam,
          value: ministry_exam_id,
        });
      }
    }
  }, [data]);

  const getAllRrbs = async () => {
    const response = await RrbApi.getAll();
    if (response) {
      setRrbs(response?.data?.records ? response.data.records : []);
    }
  };

  useEffect(() => {
    getAllRrbs();
  }, []);

  const selectedRrb = watch('rrb');

  useEffect(() => {
    fetchDashboardData(
      selectedExam?.value,
      selectedExamDay?.value,
      selectedRrb?.value
    );
  }, [selectedRrb, selectedExamDay]);

  return (
    <>
      <Col md='12'>
        <Card className='bg-transparent shadow-none border-0 '>
          <Card.Body className=''>
            <Row className='d-flex align-items-center'>
              <Col md='8' className='p-0 m-0'>
                <h2 className='page-title'>Exams Stats</h2>
              </Col>
              <Col md='2'>
                <FormFieldSelect
                  name='exam'
                  control={control}
                  options={exams.map((exam) => ({
                    label: exam.exam_name,
                    value: exam.id,
                  }))}
                  error={dashboardFilterError?.role}
                  size='12'
                  placeholder='Select Exam'
                />
              </Col>
              <Col md='2'>
                <FormFieldSelect
                  name='examDay'
                  control={control}
                  options={[
                    { label: 'All Exam Days', value: null },
                    ...examDays.map((day) => ({
                      label: moment(day.date).format('DD/MM/YYYY'),
                      value: day.date,
                    })),
                  ]}
                  error={dashboardFilterError?.role}
                  size='12'
                  placeholder='All Exam Days'
                  disabled={!getValues('exam')}
                />
              </Col>
            </Row>
          </Card.Body>
          {data?.onGoingExamsStats?.exam?.post?.name ? (
            <Card.Body className='p-3 bg-white shadow-sm card   rounded'>
              <ExamCounter data={data?.onGoingExamsStats} className='mb-3' />
              <IncidentAnalytics
                data={data?.onGoingExamsStats}
                className='mb-3'
                filter={true}
              >
                <Col md='2'>
                  <FormFieldSelect
                    name='rrb'
                    control={control}
                    options={[
                      { label: 'All RRBs', value: null },
                      ...rrbs.map((rrb) => ({
                        label: `${rrb?.name} (${rrb?.city})`,
                        value: rrb.id,
                      })),
                    ]}
                    error={dashboardFilterError?.rrb}
                    size='12'
                    placeholder='Select Rrb'
                    disabled={parentLoading}
                  />
                </Col>
              </IncidentAnalytics>
              <AttendanceProgress
                data={data?.onGoingExamsStats}
                className='mb-3'
              />
              <ReportingProgress
                data={data?.onGoingExamsStats}
                className='mb-3'
              />
              <RRBExamSchedule
                data={data?.onGoingExamsStats?.dateWiseRrrbCenters}
                className='mb-3'
              />
              <AadharCandidates
                className='mb-3'
                selectedExamDay={selectedExamDay}
                selectedExam={selectedExam}
                examDays={examDays}
              />
              <RRBContacts data={data?.onGoingExamsStats} />
            </Card.Body>
          ) : (
            <NoDataFound
              message='No active exams currently. Please select exam/exam day filters to see past exam data.'
              minHeight={isMobile ? '80vh' : '50vh'}
            />
          )}
        </Card>
      </Col>
      {isLoading && <Loader />}
    </>
  );
};

export default SuperAdminDashboard;
